import s from './Container.module.scss';
import {TContainerProps} from "@/app/[locale]/common/components/Container/types";

export const Container = ({ children }: TContainerProps) => {
    return (
        <div className={s.container}>
            { children }
        </div>
    );
};